<script lang="ts" setup>
import type { ProductVariation } from '~/types/products'

defineProps<{
  variations: ProductVariation[]
}>()

const route = useRoute()
</script>

<template>
  <div v-if="variations.length" class="mb-4 flex flex-col space-y-4">
    <div v-for="{ attributeId, attributeName, values } in variations" :key="attributeId">
      <div class="mb-1">
        {{ attributeName }}
      </div>
      <div class="-m-1 flex flex-wrap">
        <NuxtLink
          v-for="{ attributeValue, productPath } in values"
          :key="productPath"
          class="
            m-1 rounded-lg border border-solid border-main-gray px-2 py-1 text-inherit
            hover:text-main-green hover:no-underline
          "
          :class="{ 'border-main-green': route.path === productPath }"
          :to="productPath"
        >
          {{ attributeValue }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
